import { render, staticRenderFns } from "./RemoveClaim.vue?vue&type=template&id=2a0d9d6e&"
import script from "./RemoveClaim.vue?vue&type=script&lang=js&"
export * from "./RemoveClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports